import React, { useState } from 'react';
import { toast } from 'react-toastify';
import ApiDatabase from '../../../../../server';
import UseContext from '../../../../../hooks/useContext';
import useModal from '../../../useModal';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import StyledInput from '../../../../styledInput/StyledInput';

const ModalPennyLaneCreateCategory = () => {
  const { toggle } = useModal();
  const { setModalDataReturn } = UseContext();
  const [label, setLabel] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const token = localStorage.getItem('xsrfToken');

  const handleSubmit = () => {
    setError('');
    if (!label.trim()) {
      setError('Le nom de la catégorie est requis');
      return;
    }

    setIsLoading(true);
    ApiDatabase.postPennyLaneCategory(
      { token, label: label.trim() },
      (data) => {
        setIsLoading(false);
        toast.success(`Catégorie "${label.trim()}" créée`);
        setModalDataReturn({ createdCategory: data });
        toggle();
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.error(err);
          setError(err?.response?.data?.message || 'Erreur lors de la création');
          setIsLoading(false);
        }
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Créer une catégorie Pennylane
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-gray-500">
            La catégorie sera créée dans votre espace Pennylane et pourra être assignée à des clients entreprise.
          </p>
          <StyledInput
            label="Nom de la catégorie"
            type="text"
            placeholder="Ex: Automobile"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            error={error}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size="SM" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="SM" color="DISABLED">
            Création...
          </Button>
        ) : (
          <Button size="SM" color="PRIMARY" onClick={handleSubmit}>
            Créer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalPennyLaneCreateCategory;
